module.exports = __webpack_public_path__ + "static/img/img-ios.bd294a8.png";